import { FabricChannel } from '@atlaskit/analytics-listeners';

export const ANALYTICS_CHANNEL: FabricChannel.aiMate = FabricChannel.aiMate;
